import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {UserVerificationService} from "../../services/user-verification.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {KeycloakService} from "../../services/keycloak.service";
import {HttpService} from "../../services/http.service";
import {RoamingCommunityMembersComponent} from "../../roaming-community-members/roaming-community-members.component";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-edit-roaming-community',
  templateUrl:'./edit-roaming-community.component.html',
})
export class EditRoamingCommunityComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  id: any;
  listInfo: Object = {};
  listStatus: Object;

  listCommunityMembers: any[];

  hasAcces: boolean;

  errorStatus: number;
  errorText: string;

  httpSubscription: Subscription;

  public statusRefreshing = false;

  @ViewChild('validate') validate: NgForm;
  @ViewChild(RoamingCommunityMembersComponent) roamingCommunityMembersComponent:RoamingCommunityMembersComponent;

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;

    //get URL parameters virtId
    this.route.params.subscribe(params => {
      this.id = params['virtId']
    });

    this.httpSubscription = this.httpService.getRoamingCommunityInfo(this.id).subscribe(data => {
      this.listInfo = data;
      this.hasAcces = true;
      this.getAllRoamingCommunityDetails();
    },
    (err) => {
      this.hasAcces = false;
      this.errorStatus = err.status;
      this.errorText = err.statusText;
    });
  }

  getAllRoamingCommunityDetails() {
  }

  communityMembersLoaded(communityMembers) {
    this.listCommunityMembers = communityMembers;
  }

  ngOnInit() {
    $(document).on("click", ".roaming-communities", function (e) {
      $("#menu1sub1").remove();
      $("#menu2sub1").remove();
      $("#menu1").removeClass("show");
    });
  }

  ngOnDestroy() {
    $("#menu2sub1").removeClass("show");
  }

  onProtocolVersionUpdated(protocolVersion) {
    this.roamingCommunityMembersComponent.protocolVersion = protocolVersion;
  }

}
